import { render, staticRenderFns } from "./batchStudentsUploadIdPhotos.vue?vue&type=template&id=38d6ce3f&scoped=true"
import script from "./batchStudentsUploadIdPhotos.vue?vue&type=script&lang=js"
export * from "./batchStudentsUploadIdPhotos.vue?vue&type=script&lang=js"
import style0 from "./batchStudentsUploadIdPhotos.vue?vue&type=style&index=0&id=38d6ce3f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38d6ce3f",
  null
  
)

export default component.exports